import axios from 'axios'
import Vue from 'vue'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, getTenantId, getTimeOffset } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  //baseURL: process.env.BASE_API,
  // 超时300S
  timeout: 300000
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 重新定義axios中请求配置有baseURL选项，表示请求URL公共部分
    config.baseURL = Vue.prototype.BASE_URL
    config.headers['Lyods-Language'] = localStorage.getItem('language') || 'zh_TW'
    if (getToken()) {
      config.headers['Authorization'] = 'Lyods ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (getTenantId()) {
      config.headers['Lyods-TenantId'] = getTenantId() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Lyods-TimeOffset'] = getTimeOffset() // 取得當前時區new Date().getTimezoneOffset()
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器- code=401则为未登录，code!=200则是服务器内部错误，code=200则是成功返回,9000为数据校验错误
service.interceptors.response.use(res => {
  // 跨域文件下载
  if (res.data && res.data.type == "multipart/form-data") {
    return res;
  }
  // Blob數據下載處理，0字節也能下載
  if (Object.prototype.toString.call(res.data) === "[object Blob]") {
    return res;
  }
  const code = res.data.code
  if (code === 401) {
    let stips = localStorage.getItem('lang-sysTips') || 'System Tips'
    let relogin = localStorage.getItem('lang-reLogin') || 'Login Again'
    let cancel = localStorage.getItem('lang-cancel') || 'Cancel'
    MessageBox.confirm(
      res.data.msg,
      stips,
      {
        confirmButtonText: relogin,
        cancelButtonText: cancel,
        type: 'warning'
      }
    ).then(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }).catch(() => {
      console.log('cancel')
    })
    // 不是200则当作异常处理
    return Promise.reject(res.data)
  } else if (code !== 200 && code !== 9000) {
    // 不是200则当作异常处理
    return Promise.reject(res.data)
  } else {
    return res.data
  }
},
  error => {
    Message({
      message: error,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js